<template>
  <div id="gifts">
    <!--礼物列表-->
    <div
      class="gifts flex-box"
      :class="{
        giftsLeft: list.length > 1 && witsh == '25%',
        giftsarround: list.length > 1 && witsh == '33%',
        giftsCenter: list.length == 1,
      }"
    >
      <div v-for="(n, index) in list" :key="index" :style="{ width: witsh }">
        <div class="gift-img relativeItem">
          <img class="absoluteItem centerImg" :src="n.giftimage" />
        </div>
        <span class="name apostrophe">{{ n.giftname }}</span>
        <span class="num" v-if="pro">{{ n.showbilie }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gifts",
  props: ["list", "pro", "witsh"],
  data() {
    return {};
  },
  methods: {},
  mounted: function () {
    this.$emit("showOhidden", false, 3);
  },
};
</script>

<style scoped lang="scss">
/*礼物列表*/
.giftsarround {
  justify-content: space-around;
}
.giftsLeft {
  justify-content: left;
}
.giftsCenter {
  justify-content: center;
}
.gifts {
  font-size: 12px;
  text-align: center;
  flex-wrap: wrap;
  max-height: 260px;
  overflow-y: scroll;
  > div {
    margin-bottom: 1rem;
  }
  .gift-img {
    width: 3.125rem;
    height: 3.125rem;
    background: rgba($color: #fff, $alpha: 0.3);
    border-radius: 0.25rem;
    margin: 0 auto;
    img {
      max-width: 90%;
    }
  }
  span {
    display: block;
  }
  .name {
    color: #fff;
    max-width: 100%;
  }
  .num {
    color: #ffd400;
  }
}
// .gifts>div:nth-child(4n){
//   margin-right: 0;
// }
// .gifts>div:last-child{
//   margin-right: 0;
// }
</style>
